import Dropdown from './Dropdown'
import { useState, useEffect, useRef } from 'react'
import { Link } from "react-router-dom";

const MenuItems = ({ items, depthLevel }) => {
  const [dropdown, setDropdown] = useState(false)
  let ref = useRef()
  useEffect(() => {
    const handler = (event) => {
      if (dropdown && ref.current && !ref.current.contains(event.target)) {
        setDropdown(false)
      }
    }
    document.addEventListener("mousedown", handler)
    document.addEventListener("touchstart", handler)
    return () => {
      document.removeEventListener("mousedown", handler)
      document.removeEventListener("touchstart", handler)
    }
  }, [dropdown])
  const onMouseEnter = () => {
    setDropdown(true)
  }
  const onMouseLeave = () => {
    setDropdown(false)
  }


  return (
    <li className="menu-items" ref={ref}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {items.submenu ? (
        <>
          <li aria-haspopup='menu' style={{ padding: 5 }}
            aria-expanded={dropdown ? 'true' : 'false'}
            onClick={() => setDropdown((prev) => !prev)}
          >
            {items.title} {' '}
            {depthLevel > 0 ? <span>&raquo</span> : <span className='arrow'></span>}
          </li>
          <Dropdown submenus={items.submenu} dropdown={dropdown} depthLevel={depthLevel} />
        </>
      ) : (
       <>
        <li className='flex justify-between p-1 mr-6 bg-[#1a1a1a] item-center border-b'>
          <Link to={items.path}>{items.title}</Link>
        </li>
       </>
      )}
    </li>
  )
}

export default MenuItems